import { render, staticRenderFns } from "./intoedOrder.vue?vue&type=template&id=708ebb10&"
import script from "./intoedOrder.vue?vue&type=script&lang=js&"
export * from "./intoedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports